import { combineReducers } from 'redux';

import { disputesCenterReducer } from './disputescenter/reducers';
import { MdrpState } from './types';

export const mdrpReducer = combineReducers<MdrpState>({
  disputesCenter: disputesCenterReducer,
});